// extracted by mini-css-extract-plugin
export default {"container":"ERiany","triangleBorder":"oEw3_Y","defaultColor":"wh3B27","triangleBackground":"hULj4j"};